import { lazy } from 'react';
import { useParams } from 'react-router';
import { useForwardedSurrenderRequest } from 'src/apis/surrender-service/use-forwarded-surrender-request';
import { useSurrenderRoot } from 'src/apis/surrender-service/use-surrender-root';
import { PageSpinner } from 'src/components/spinner-container';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const SurrenderDetails = () => {
  const surrenderRoot = useSurrenderRoot();
  const { surrenderRequestId } = useParams<{ surrenderRequestId?: string }>();
  const forwardedSurrenderRequest = useForwardedSurrenderRequest({
    surrenderRoot,
    surrenderRequestId,
  });

  if (!surrenderRequestId) throw new Forbidden();
  if (!surrenderRoot.response || !forwardedSurrenderRequest?.response)
    return <PageSpinner />;

  return (
    <Page
      surrenderRoot={surrenderRoot}
      forwardedSurrenderRequest={forwardedSurrenderRequest}
    />
  );
};
